import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate, useParams } from "react-router-dom";
import { getUserById } from "../models/UserFunctions.js";
import { getOrgByRef } from "../models/OrgFunctions.js";
import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import { Skeleton } from "@mui/material";
import TextField2 from "../textfields/TextField2.js";
import { useSnackbar } from "notistack";
import { useAppContext } from "../config/AppContext.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getFlutterTimeFromSeconds,
  last_of_list,
  updateDocDataField,
} from "../models/DataFunctions.js";
import DropDownGPT0 from "../dropdowns/DropDownGTP0.js";
import { DatePicker } from "antd";
import sendRTBatiment from "../api/send/sendRTBatiment.js";
import PdfEditor from "../sign/model/PdfEditor.js";
import DropDownGPT1 from "../dropdowns/DropDownGPT1.js";
import Modal1 from "../modals/Modal1.js";
import TimedProgressBar from "../loading/TimedProgressBar.js";
import sign from "../api/sign/sign.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import sendErrorDiscord from "../api/sendErrorDiscord.js";
import moment from "moment";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import TextField2T from "../textfields/TextField2T.js";
import DatePickerGPT0 from "../textfields/DatePickerGPT0.js";
import dayjs from "dayjs";

function RTBModal({
  userData,
  orgData,
  folderData,
  forcePageReload,
  onClose,
  navigateWorkspace,
}) {
  const { currentUser, loading } = useAuth();

  const [rtb, setRtb] = useState(null);

  const [operators, setOperators] = useState([]);
  const [operator, setOperator] = useState(null);

  const [file_url, setFileUrl] = useState(null);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [step, setStep] = useState(0);
  const [rtbFileName, setRtbFileName] = useState(null);
  const [folder, setFolder] = useState(folderData);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [use_maj_xml, setUseMajXml] = useState(false);
  const [can_change_maj_xml, setCanChangeMajXml] = useState(false);
  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (orgData) {
      try {
        let rtb = orgData.rtb || {};
        rtb.operation_fc_form_auteur_nom = null;

        const users = await getArrayDocDataByID("user", orgData.users_id);
        const operators = users.filter((user) => user.role === "operator");
        setRtb(rtb);
        setOperators(operators);

        const folder = await getDocDataById("folder", folderData.id);
        if (folder.xml?.file?.id && !folder.modif_thermal?.xml?.file?.id) {
          setCanChangeMajXml(false);
          setUseMajXml(false);
        }
        if (!folder.xml?.file?.id && folder.modif_thermal?.xml?.file?.id) {
          setCanChangeMajXml(false);
          setUseMajXml(true);
        }
        if (folder.xml?.file?.id && folder.modif_thermal?.xml?.file?.id) {
          setCanChangeMajXml(true);
          setUseMajXml(false);
        }
        if (!folder.xml?.file?.id && !folder.modif_thermal?.xml?.file?.id) {
          handleClickVariant("Aucun xml n'a été déposé", "error");
          onClose();
        }
        if (
          folder.payment_allowed &&
          (!folder.reglement.payments || folder.reglement.payments.length === 0)
        ) {
          handleClickVariant(
            "Comme c'est un dossier avec paiement particulier, il faut créer un paiement pour pouvoir lancer le RTB",
            "error"
          );
          onClose();
        }
        if (
          !folder.payment_allowed &&
          (!folder.rapport.slots || folder.rapport.slots.length === 0)
        ) {
          handleClickVariant(
            "Comme c'est un dossier sans paiement particulier, il faut créer un emplacement de rapport pour pouvoir lancer le RTB",
            "error"
          );
          onClose();
        }
        setFolder(folder);

        if (folderData.members_id?.length > 0) {
          handleSetOperator(
            {
              value: folderData.members_id[0],
              label:
                operators.find(
                  (operator) => operator.id === folderData.members_id[0]
                )?.display_name || "Aucun opérateur",
            },
            rtb
          );
        } else if (operators.length > 0) {
          handleSetOperator(
            {
              value: operators[0].id,
              label: operators[0].display_name,
            },
            rtb
          );
        } else {
          handleSetOperator(null, rtb);
        }

        // Update state with fetched data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  function checkFieldsFilled() {
    if (!date) {
      handleClickVariant("Veuillez renseigner une date", "error");
      return false;
    }
    if (!operator) {
      handleClickVariant("Veuillez renseigner un opérateur", "error");
      return false;
    }
    let operator_obj = operators.find((operat) => operat.id === operator);
    if (!operator_obj.sign_url || operator_obj.sign_url === "") {
      handleClickVariant(
        "L'opérateur n'a pas renseigné d'url de signature",
        "error"
      );
      return false;
    }

    if (
      !rtb.operation_fc_form_auteur_societe ||
      rtb.operation_fc_form_auteur_societe === ""
    ) {
      handleClickVariant("Veuillez renseigner le nom de l'entreprise", "error");
      return false;
    }
    if (
      !rtb.operation_fc_form_auteur_cp ||
      rtb.operation_fc_form_auteur_cp === ""
    ) {
      handleClickVariant("Veuillez renseigner le code postal", "error");
      return false;
    }
    if (
      !rtb.operation_fc_form_auteur_localite ||
      rtb.operation_fc_form_auteur_localite === ""
    ) {
      handleClickVariant("Veuillez renseigner la localité", "error");
      return false;
    }
    if (
      !rtb.operation_fc_form_auteur_adresse1 ||
      rtb.operation_fc_form_auteur_adresse1 === ""
    ) {
      handleClickVariant("Veuillez renseigner l'adresse", "error");
      return false;
    }
    if (
      !rtb.operation_fc_form_auteur_qualite ||
      rtb.operation_fc_form_auteur_qualite === ""
    ) {
      handleClickVariant("Veuillez renseigner la qualité", "error");
      return false;
    }
    if (
      !rtb.operation_fc_form_xml_depose ||
      rtb.operation_fc_form_xml_depose === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la fourniture du récapitulatif standardisé d'étude énergétique",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_perimetre_reseau_chaleur ||
      rtb.batiment_fc_form_perimetre_reseau_chaleur === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner si le bâtiment est situé dans un périmètre de développement prioritaire d'un réseau de chaleur ou de froid classé",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_perimetre_reseau_chaleur_derogation ||
      rtb.batiment_fc_form_perimetre_reseau_chaleur_derogation === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner si une dérogation à l’obligation de raccordement a-t-elle été obtenue",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_cep_nr_coherence ||
      rtb.batiment_fc_form_cep_nr_coherence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site du nombre et du type de générateur",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_ic_construction_documents ||
      rtb.batiment_fc_form_ic_construction_documents === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la fourniture de documents justifiant des quantitatifs et des références des produits renseignés dans le récapitulatif standardisé d'étude énergétique et environnementale par le maître d'ouvrage",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_ic_construction_coherence1 ||
      rtb.batiment_fc_form_ic_construction_coherence1 === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site des systèmes de ventilation installés",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_ic_construction_coherence2 ||
      rtb.batiment_fc_form_ic_construction_coherence2 === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site des systèmes de ventilation installés",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_isolants_fourniture_documents ||
      rtb.batiment_fc_form_isolants_fourniture_documents === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la fourniture de documents justifiant des isolants posés par le maître d'ouvrage",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_isolants_coherence ||
      rtb.batiment_fc_form_isolants_coherence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le document de justification des isolants posés par le maître d'ouvrage",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_isolants_respect_exigence ||
      rtb.batiment_fc_form_isolants_respect_exigence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner le respect de l'exigence U ≤ 0,36 W/(m².K) pour l'ensemble des isolants",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_protections_solaires_presence ||
      rtb.batiment_fc_form_protections_solaires_presence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la présence de protections solaires",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_protections_solaires_coherence ||
      rtb.batiment_fc_form_protections_solaires_coherence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site des protections solaires",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_protections_solaires_respect_exigence ||
      rtb.batiment_fc_form_protections_solaires_respect_exigence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner le respect de l'exigence U ≤ 0,36 W/(m².K) pour l'ensemble des isolants",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_permeabilite_air_igh ||
      rtb.batiment_fc_form_permeabilite_air_igh === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner si le projet est un IGH ou la Sref > 3 000 m2",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_permeabilite_air_document_justification ||
      rtb.batiment_fc_form_permeabilite_air_document_justification === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner le document de justification transmis par le maître d'ouvrage pour la perméabilité à l'air",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_permeabilite_air_fourniture_rapport ||
      rtb.batiment_fc_form_permeabilite_air_fourniture_rapport === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la fourniture du rapport de mesure pour la perméabilité à l'air",
        "error"
      );
      return false;
    }
    if (
      !rtb.batiment_fc_form_titre_v_systeme_coherence ||
      rtb.batiment_fc_form_titre_v_systeme_coherence === ""
    ) {
      handleClickVariant(
        "Veuillez renseigner la cohérence entre l'agrément ministériel et le récapitulatif standardisé d'étude énergétique et environnementale",
        "error"
      );
      return false;
    }

    return true;
  }
  const [loadingOpen, setLoadingOpen] = useState(false);
  const [date, setDate] = useState(null);
  const handleLaunchRTB = async () => {
    try {
      if (!checkFieldsFilled()) {
        return;
      }
      let date_dayjs = date;
      if (date_dayjs === null) {
        handleClickVariant("Veuillez renseigner une date", "error");
        return;
      }

      let date_format = dayjs.unix(date_dayjs.seconds).format("YYYY-MM-DD");
      rtb.operation_fc_form_date_visite = date_format;
      await updateDocDataFieldApi(orgData.ref, "rtb_ready", rtb, prefix);
      setLoadingOpen(true);

      const token = await getOrRefreshFirebaseToken();
      const maj = use_maj_xml;
      const responses = await sendRTBatiment(
        folderData.id,
        userData.id,
        maj,
        token,
        prefix
      );
      if (responses.success) {
        setRtbFileName(responses.filename);
        await getTemporaryUrl(token, "rapport", "vide", folderData.id, prefix);
        await getTemporaryUrl(
          token,
          "rapport-payment",
          "vide",
          folderData.id,
          prefix
        );

        const newfolder = await getDocDataByRef(folder.ref);
        let file_url = null;

        if (folder.payment_allowed) {
          let payments_refs = newfolder.reglement.payments;
          let last_payment = await getDocDataByRef(last_of_list(payments_refs));
          let rtbFile = last_payment.rapport_files.find(
            (file) => file.name === responses.filename
          );
          file_url = rtbFile.url;
        } else {
          let slots_refs = newfolder.rapport.slots;
          let last_slot = await getDocDataByRef(last_of_list(slots_refs));
          let rtbFile = last_slot.files.find(
            (file) => file.name === responses.filename
          );
          file_url = rtbFile.url;
        }
        setFileUrl(file_url);
        setFolder(newfolder);
        setLoadingOpen(false);
        handleClickVariant("Rapport rt batiment généré", "success");
        setStep(1);
      } else {
        handleClickVariant(
          "Erreur lors de la génération du rapport RTB",
          "error"
        );
        await sendErrorDiscord(
          "Erreur génération de rapport RTB " + responses.message
        );
        setLoadingOpen(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSignRTB = async () => {
    try {
      handleClickVariant("Attestation signée avec succès", "success");
      forcePageReload();
      onClose();
    } catch (error) {
      message.error(
        "Une erreur s'est produite. Merci de réessayer ultérieurement.",
        5
      );
    }
  };

  const handleSetOperator = (value, used_rtb) => {
    if (!value) return;
    setRtb({
      ...(used_rtb || rtb),
      operation_fc_form_auteur_nom: value.label,
    });
    setOperator(value.value);
  };

  useEffect(() => {
    if (orgData) {
      handleFetchData();
    }
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose(); // Close the modal if clicked on the backdrop
    }
  };

  if (loading || !currentUser || !orgData || !rtb) {
    return (
      <div className="w-full h-full overflow-auto flex flex-row gap-2 mt-3">
        {/* Left Column Skeleton */}
        <Space y={20} />
        <div className="h-full flex-grow pl-4 flex flex-col gap-2 max-w-c1p2k">
          {/* Skeleton for the title and buttons */}
          <div className="flex flex-row w-full justify-between">
            <Skeleton variant="rounded" width={100} height={25} />

            <div className="flex flex-row gap-2">
              <Skeleton variant="rounded" width={100} height={25} />
              <Skeleton variant="rounded" width={100} height={25} />
            </div>
          </div>
          <Skeleton variant="rounded" width={200} height={30} />
          <Skeleton variant="rounded" width={100} height={25} />
          <Space y={10} />
        </div>
      </div>
    );
  }

  return (
    <div
      className="w-screen h-screen flex flex-row items-center justify-center "
      onClick={handleBackdropClick}
    >
      <Modal1 isOpen={loadingOpen} onClose={() => setLoadingOpen(false)}>
        <div className="flex flex-col bg-white p-3 rounded-2xl">
          <div className="text-h4 text-shadow_50">Génération en cours</div>
          <TimedProgressBar time={10000} />
        </div>
      </Modal1>
      <div
        className="flex flex-col w-full  rounded-xl h-full 
      max-h-c500 max-w-c700 overflow-auto bg-white"
      >
        <div className="flex flex-col  overflow-y-auto h-fit w-full">
          <div className="flex flex-col  w-full">
            {step === 0 && (
              <div className="flex flex-col  ">
                <div className="text-h1 text-black font-medium flex flex-row justify-between p-4 border-b-1">
                  Formulaire RE 2020
                  <div className="flex flex-row gap-2">
                    <SecondaryButton
                      className="w-fit"
                      onClick={() => navigateWorkspace("/rtb?section=form")}
                    >
                      Configurer le formulaire par défaut
                    </SecondaryButton>
                    <SecondaryButton
                      className="w-fit"
                      onClick={() => onClose()}
                    >
                      Annuler
                    </SecondaryButton>
                  </div>
                </div>
                <div className="flex flex-col gap-2 p-4 bg-neutral-50">
                  <div className="text-h3 text-shadow_50 font-semibold">
                    Champs informations
                  </div>
                  <div className="flex flex-col gap-1 w-c500">
                    <DropDownGPT03
                      label={"Opérateur"}
                      items={operators.map((operator) => ({
                        value: operator.id,
                        label: operator.display_name,
                      }))}
                      transparent={false}
                      value={
                        rtb.operation_fc_form_auteur_nom
                          ? operators.find(
                              (operator) =>
                                operator.display_name ===
                                rtb.operation_fc_form_auteur_nom
                            )?.id
                          : null
                      }
                      onChange={(value) => handleSetOperator(value, rtb)}
                    />

                    <TextField2T
                      label={"Nom entreprise"}
                      value={rtb.operation_fc_form_auteur_societe}
                      field={"operation_fc_form_auteur_societe"}
                      onChange={(e) =>
                        setRtb({
                          ...rtb,
                          operation_fc_form_auteur_societe: e.target.value,
                        })
                      }
                    ></TextField2T>
                    <TextField2T
                      label={"Code postal"}
                      value={rtb.operation_fc_form_auteur_cp}
                      field={"operation_fc_form_auteur_cp"}
                      onChange={(e) =>
                        setRtb({
                          ...rtb,
                          operation_fc_form_auteur_cp: e.target.value,
                        })
                      }
                    ></TextField2T>
                    <TextField2T
                      label={"Localité"}
                      value={rtb.operation_fc_form_auteur_localite}
                      field={"operation_fc_form_auteur_localite"}
                      onChange={(e) =>
                        setRtb({
                          ...rtb,
                          operation_fc_form_auteur_localite: e.target.value,
                        })
                      }
                    ></TextField2T>
                    <TextField2T
                      label={"Adresse"}
                      value={rtb.operation_fc_form_auteur_adresse1}
                      field={"operation_fc_form_auteur_adresse1"}
                      onChange={(e) =>
                        setRtb({
                          ...rtb,
                          operation_fc_form_auteur_adresse1: e.target.value,
                        })
                      }
                    ></TextField2T>
                    <div className="flex flex-col gap-2 w-full">
                      <div className="flex flex-row gap-4 ">
                        <DropDownGPT0
                          label={" En qualité de"}
                          items={[
                            {
                              value: "1",
                              label: "Organisme de contrôle technique",
                            },
                            {
                              value: "2",
                              label: "Architecte",
                            },
                            {
                              value: "3",
                              label:
                                "Diagnostiqueur de performance énergétique",
                            },
                            {
                              value: "4",
                              label:
                                "Organisme ayant certifié la performance énergétique d’un nouveau bâtiment et ayant signé une convention avec le ministre chargé de la construction",
                            },
                            {
                              value: "5",
                              label: "Bureau d'étude agréé",
                            },
                          ]}
                          value={rtb.operation_fc_form_auteur_qualite}
                          onChange={(value) =>
                            setRtb({
                              ...rtb,
                              operation_fc_form_auteur_qualite: value,
                            })
                          }
                          className="w-c500"
                        />{" "}
                      </div>
                    </div>
                    <Space y={10} />

                    <DatePickerGPT0
                      seconds={date?.seconds}
                      onChange={(seconds) =>
                        setDate(getFlutterTimeFromSeconds(seconds))
                      }
                      disableAfterToday={true}
                      mandatory={true}
                      transparent={false}
                    />

                    <div className="text-h3 text-shadow_50 font-semibold flex flex-row gap-2 mt-2">
                      <CheckBoxGrey
                        checked={use_maj_xml}
                        disabled={!can_change_maj_xml}
                        onChange={(checked) => setUseMajXml(checked)}
                      ></CheckBoxGrey>{" "}
                      <div>Utiliser le xml de MAJ</div>
                    </div>

                    <Space y={10} />
                  </div>
                  <Space y={30} />
                  <div className="text-h3 text-shadow_50 font-semibold">
                    Champs batiment
                  </div>
                  <Space y={10} />
                  <div className="flex flex-col gap-2  w-full">
                    <DropForm
                      label={
                        "Fourniture du récapitulatif standardisé d'étude énergétique"
                      }
                      value={rtb.operation_fc_form_xml_depose}
                      onChange={(value) =>
                        setRtb({ ...rtb, operation_fc_form_xml_depose: value })
                      }
                    />

                    <DropForm
                      label={
                        "Le bâtiment est-il situé dans un périmètre de développement prioritaire d'un réseau de chaleur ou de froid classé ?"
                      }
                      value={rtb.batiment_fc_form_perimetre_reseau_chaleur}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_perimetre_reseau_chaleur: value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Une dérogation à l’obligation de raccordement a-t-elle été obtenue ?"
                      }
                      value={
                        rtb.batiment_fc_form_perimetre_reseau_chaleur_derogation
                      }
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_perimetre_reseau_chaleur_derogation:
                            value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Pour les générateurs de chaleur ou de froid utilisés pour le chauffage, la production d'eau chaude sanitaire et/ou le refroidissement des locaux la cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site du nombre et du type de générateur"
                      }
                      value={rtb.batiment_fc_form_cep_nr_coherence}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_cep_nr_coherence: value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Fourniture de documents justifiant des quantitatifs et des références des produits renseignés dans le récapitulatif standardisé d'étude énergétique et environnementale par le maître d'ouvrage"
                      }
                      value={rtb.batiment_fc_form_ic_construction_documents}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_ic_construction_documents: value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Pour les données d'entrée du calcul des indicateurs d'impact sur le changement climatique du bâtiment sélectionnées, les documents justifiant des quantitatifs et des références des produits renseignés dans le récapitulatif standardisé d'étude énergétique et environnementale et le récapitulatif standardisé d'étude énergétique et environnementale sont cohérents"
                      }
                      value={rtb.batiment_fc_form_ic_construction_coherence1}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_ic_construction_coherence1: value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Pour les données d'entrée du calcul des indicateurs d'impact sur le changement climatique du bâtiment sélectionnées, les documents justifiant des quantitatifs et des références des produits renseignés dans le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site sont cohérents"
                      }
                      value={rtb.batiment_fc_form_ic_construction_coherence2}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_ic_construction_coherence2: value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Fourniture de documents de justification des isolants posés par le maître d'ouvrage"
                      }
                      value={rtb.batiment_fc_form_isolants_fourniture_documents}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_isolants_fourniture_documents: value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Pour l'ensemble des isolants, cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le document de justification des isolants posés par le maître d'ouvrage"
                      }
                      value={rtb.batiment_fc_form_isolants_coherence}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_isolants_coherence: value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Pour l'ensemble des isolants, respect de l'exigence U ≤ 0,36 W/(m².K)"
                      }
                      value={rtb.batiment_fc_form_isolants_respect_exigence}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_isolants_respect_exigence: value,
                        })
                      }
                    />
                    <DropForm
                      label={"Présence de protections solaires"}
                      value={rtb.batiment_fc_form_protections_solaires_presence}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_protections_solaires_presence: value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site"
                      }
                      value={
                        rtb.batiment_fc_form_protections_solaires_coherence
                      }
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_protections_solaires_coherence:
                            value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "À l'exception des baies des locaux à occupation passagère, les baies ont un facteur solaire inférieur ou égal au facteur solaire défini dans le tableau de l'article 24 de l'arrêté du 4 août 2021"
                      }
                      value={
                        rtb.batiment_fc_form_protections_solaires_respect_exigence
                      }
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_protections_solaires_respect_exigence:
                            value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Le projet est un IGH ou la Sref du projet > 3 000 m² ?"
                      }
                      value={rtb.batiment_fc_form_permeabilite_air_igh}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_permeabilite_air_igh: value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Document de justification transmis par le maître d'ouvrage"
                      }
                      items={[
                        { value: "1", label: "Mesure sur site" },
                        { value: "2", label: "Démarche qualité" },
                      ]}
                      value={
                        rtb.batiment_fc_form_permeabilite_air_document_justification
                      }
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_permeabilite_air_document_justification:
                            value,
                        })
                      }
                    />
                    {rtb
                      ?.batiment_fc_form_permeabilite_air_document_justification
                      ?.value === "1" && (
                      <>
                        {" "}
                        <DropForm
                          label={"Fourniture du rapport de mesure"}
                          value={
                            rtb.batiment_fc_form_permeabilite_air_fourniture_rapport
                          }
                          onChange={(value) =>
                            setRtb({
                              ...rtb,
                              batiment_fc_form_permeabilite_air_fourniture_rapport:
                                value,
                            })
                          }
                        />
                        <DropForm
                          label={
                            "Le mesureur qui a signé le rapport de mesure figure sur la liste des mesureurs autorisés par le ministère chargé de la construction"
                          }
                          value={
                            rtb.batiment_fc_form_permeabilite_air_mesureur_autorise
                          }
                          onChange={(value) =>
                            setRtb({
                              ...rtb,
                              batiment_fc_form_permeabilite_air_mesureur_autorise:
                                value,
                            })
                          }
                        />
                      </>
                    )}
                    {rtb
                      ?.batiment_fc_form_permeabilite_air_document_justification
                      ?.value === "2" && (
                      <>
                        {" "}
                        <DropForm
                          label={
                            "Fourniture des documents certifiant la démarche qualité du maître d'ouvrage"
                          }
                          value={
                            rtb.batiment_fc_form_permeabilite_air_qualite_documents
                          }
                          onChange={(value) =>
                            setRtb({
                              ...rtb,
                              batiment_fc_form_permeabilite_air_qualite_documents:
                                value,
                            })
                          }
                        />
                        <DropForm
                          label={
                            "Le certificateur qui a signé les documents la démarche qualité du maître d'ouvrage figure sur la liste des certificateurs autorisés par le ministère chargé de la construction"
                          }
                          value={
                            rtb.batiment_fc_form_permeabilite_air_qualite_certificateur
                          }
                          onChange={(value) =>
                            setRtb({
                              ...rtb,
                              batiment_fc_form_permeabilite_air_qualite_certificateur:
                                value,
                            })
                          }
                        />
                      </>
                    )}

                    <DropForm
                      label={
                        "Cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et les documents justificatifs de l'exigence sur la perméabilité à l'air du bâtiment"
                      }
                      value={rtb.batiment_fc_form_permeabilite_air_coherence}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_permeabilite_air_coherence: value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Cohérence entre le récapitulatif standardisé d'étude énergétique et environnementale et le contrôle visuel sur site des systèmes de ventilation installés"
                      }
                      value={rtb.batiment_fc_form_ventilation_coherence}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_ventilation_coherence: value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Un opérateur reconnu compétent par le ministre chargé de la construction a vérifié la conformité des systèmes de ventilation"
                      }
                      value={rtb.batiment_fc_form_ventilation_operateur}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_ventilation_operateur: value,
                        })
                      }
                      items={[
                        { value: "1", label: "Oui" },
                        { value: "0", label: "Non" },
                        { value: "2", label: "Non concerné*" },
                      ]}
                    />
                    <DropForm
                      label={
                        "Conformité du système de ventilation attestée par le rapport de vérifications et de mesure fourni par le maître d'ouvrage"
                      }
                      value={rtb.batiment_fc_form_ventilation_conformite}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_ventilation_conformite: value,
                        })
                      }
                    />
                    <DropForm
                      label={
                        "Cohérence entre l'agrément ministériel et le récapitulatif standardisé d'étude énergétique et environnementale"
                      }
                      value={rtb.batiment_fc_form_titre_v_systeme_coherence}
                      onChange={(value) =>
                        setRtb({
                          ...rtb,
                          batiment_fc_form_titre_v_systeme_coherence: value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-row justify-end gap-2  p-4 border-t-1">
                  <SecondaryButton className="w-fit" onClick={onClose}>
                    Annuler
                  </SecondaryButton>
                  <PrimaryButton
                    className="w-fit"
                    type="submit"
                    onClick={handleLaunchRTB}
                    disabled={date === null || operator === null || loading}
                  >
                    Lancer la génération
                  </PrimaryButton>
                </div>
              </div>
            )}
            {step === 1 && (
              <div className="absolute top-0 left-0 flex flex-col h-screen w-screen items-center justify-center">
                <div className=" flex flex-col h-5/6 w-5/6  ">
                  {file_url && (
                    <PdfEditor
                      folder={folder}
                      document={null}
                      file_url={file_url}
                      rt_batiment={true}
                      onFetch={handleSignRTB}
                      operator_id={operator}
                      onClose={onClose}
                      userData={userData}
                      fileName={rtbFileName}
                    />
                  )}
                </div>
              </div>
            )}

            <Space y={30} />
          </div>{" "}
        </div>
      </div>
    </div>
  );
}

export default RTBModal;

const DropForm = ({
  label,
  value,
  onChange,
  items = [
    { value: "1", label: "Oui" },
    { value: "0", label: "Non" },
  ],
}) => {
  return (
    <div className="flex flex-col gap-2 ">
      <div className="flex flex-row gap-2 ">
        <div className="text-shadow_50 text-h3 w-c700">{label}</div>
        <DropDownGPT0
          label={"Choisir"}
          items={items}
          value={value}
          onChange={(value) => onChange(value)}
          className="w-c200"
        />{" "}
      </div>
      <Divider orientation="horizontal" />
    </div>
  );
};

const TextForm = ({ label, value, onChange, rtb }) => {
  return (
    <div className="flex flex-row gap-2 ">
      <div className="text-shadow_50 text-h3 w-c200">{label}</div>

      <TextField2
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      ></TextField2>
    </div>
  );
};
